module.exports = [{"type":"title","text":"2024-08-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"現貨:新增一個websocket只能成功訂閱200個dataType的限制。"},{"type":"html","text":"現貨:新增一個ip只能最多60個websocket的限制。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-08-17.json
// module id = aG00
// module chunks = 3